import React from "react";
import Chart from "react-apexcharts";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import { commonColors } from "../../../../theme/colors";

const ApexPieChart = ({ dataNutrition, isDashboard = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Transform the data: ApexCharts expects a series (array of values) and labels (array of strings)
  const series = dataNutrition.map((item) => item.value);
  const labels = dataNutrition.map((item) => item.label);

  const options = {
    chart: {
      type: "donut",
      animations: { enabled: true },
      foreColor: colors.grey[100],
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    },
    labels: labels,
    colors: [commonColors.protein, commonColors.carbs, commonColors.fat],
    plotOptions: {
      pie: {
        donut: {
          size: "50%",
          labels: {
            show: true,
            total: {
              show: !isDashboard, // optionally show total when not in dashboard mode
              label: "Total",
              formatter: (w) => {
                const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                return total;
              },
              style: {
                fontSize: "18px",
                color: "#333333",
              },
              dropShadow: { enabled: false },
            },
            name: {
              show: true,
              fontSize: "18px",
              color: "black",
              dropShadow: { enabled: false },
            },
            value: {
              show: true,
              fontSize: "18px",
              color: "black",
              dropShadow: { enabled: false },
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      dropShadow: { enabled: false },
      style: {
        fontSize: "18px",
        colors: ["black"],
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "18px",
      labels: {
        colors: "#000",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      },
      offsetY: 0,
    },
    tooltip: {
      theme: "dark",
      style: { fontSize: "14px" },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 300 },
          legend: { position: "bottom" },
          dataLabels: { style: { fontSize: "12px" } },
        },
      },
    ],
  };

  return <Chart options={options} series={series} type="donut" height="350" />;
};

export default ApexPieChart;
